<div class="col-12">
  <div class="mt-3">
    <h5>{{ 'MODAL_NEW_OFFER.MERCHANDISE_TYPE.TITLE' | translate }}</h5>
    <p>{{ 'MODAL_NEW_OFFER.MERCHANDISE_TYPE.DESCRIPTION' | translate }}</p>
    <jhi-bary-cards-selector [control]="getFormControl('merchandiseType')" [cards]="OFFER_MERCHANDISE_TYPE" (valueChanges)="updateForm($event)"></jhi-bary-cards-selector>
  </div>
  <div class="mt-4" *ngIf="getFormControl('merchandiseType').value === null || getFormControl('merchandiseType').value === CONDITIONED">
    <h5>{{ 'MODAL_NEW_OFFER.SERVICE_TYPE.TITLE' | translate }}</h5>
    <p>{{ 'MODAL_NEW_OFFER.SERVICE_TYPE.DESCRIPTION' | translate }}</p>
    <jhi-bary-cards-selector [control]="getFormControl('serviceType')" [cards]="SERVICE_TYPE"></jhi-bary-cards-selector>
  </div>
</div>
<div class="modal-body text-left mt-4">
  <h5>{{ (isOffer ? 'MODAL_NEW_OFFER.OFFER_NATURE.TITLE' : 'MODAL_ESTIMATE.BLOCK_SPECIFICITY.TITLE') | translate }}</h5>
  <p>{{ (isOffer ? 'MODAL_NEW_OFFER.OFFER_NATURE.DESCRIPTION' : 'MODAL_ESTIMATE.BLOCK_SPECIFICITY.BODY') | translate }}</p>
  <jhi-bary-input-checkbox
    (onChangeEvent)="getFormControl('isHazardousMaterial').setValue(false)"
    [label]="'TRANSPORT_TYPOLOGY.CONTROLLED_TEMPERATURE' | translate"
    [control]="getFormControl('isControlledTemperature')"
  >
  </jhi-bary-input-checkbox>
  <jhi-bary-input-checkbox
    (onChangeEvent)="getFormControl('isControlledTemperature').setValue(false)"
    [label]="'LABEL.ADR' | translate"
    [control]="getFormControl('isHazardousMaterial')"
  >
  </jhi-bary-input-checkbox>
</div>
